import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import capitalizeString from 'utils/capitalize'
import { sortAndJoinCriterias } from 'utils/sitesTableHelpers'
import {
  KbaCriteriaSummaryWrapper,
  KbaCriteriaSummaryLine,
  KbaCriteriaSummaryLabel,
  KbaCriteriaSummaryValues
} from './style'

const formatCriteriaList = (criteria = []) => {
  if (!Array.isArray(criteria) || criteria.length === 0) {
    return ''
  }

  return sortAndJoinCriterias(criteria.map((item) => capitalizeString(item)))
}

/**
 * Displays the concatenated KBA criteria met across all triggers at the top of
 * the Assessment and Criteria met tabs.
 */
const KbaCriteriaSummary = ({ criteria = [], isLoading = false, marginTop }) => {
  const displayCriteria = useMemo(() => formatCriteriaList(criteria), [criteria])

  if (isLoading || !displayCriteria) {
    return null
  }

  return (
    <KbaCriteriaSummaryWrapper
      data-testid="kba-criteria-summary"
      data-test="kba-criteria-summary"
      marginTop={marginTop}
    >
      <KbaCriteriaSummaryLine>
        <KbaCriteriaSummaryLabel>
          <FormattedMessage id="kbaCriteriaMetOverall" />:
        </KbaCriteriaSummaryLabel>
        <KbaCriteriaSummaryValues data-testid="kba-criteria-summary-value">
          {displayCriteria}
        </KbaCriteriaSummaryValues>
      </KbaCriteriaSummaryLine>
    </KbaCriteriaSummaryWrapper>
  )
}

KbaCriteriaSummary.propTypes = {
  criteria: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  marginTop: PropTypes.string
}

export default KbaCriteriaSummary
